import { FC, memo, useMemo } from 'react';
import { getKsdmConfig } from '../../helpers/index';
import Tooltip from './components/atom/Tooltip';
import './KaiSelectFooter.scss';

const VersionItem: FC<{ title: string; value?: string }> = ({ title, value }) => (
  <Tooltip title={title} placement="top">
    <span>{value || ''}</span>
  </Tooltip>
);

/**
 * `#ksdm-footer` for the KAI Select page — same shape as the source project's
 * standalone Footer, but reading version info off the config that
 * ReactAppAuthView already injects (matching how the other ported pages'
 * footers do it) instead of a separate versions API call.
 */
const KaiSelectFooter = () => {
  const cfg = getKsdmConfig();
  const currentYear = cfg?.year ?? new Date().getFullYear();

  const versions = useMemo(() => {
    const v = cfg?.versions;
    if (!v) return null;
    return {
      software: v.software || '',
      master: v.master || '',
      cms: v.cms || '',
    };
  }, [cfg]);

  return (
    <footer id="ksdm-footer">
      <div>
        <span id="ksdm-copyright">
          Powered by Kinetix Air | &#169; {currentYear} Kinetix Software LLC | All Rights
          Reserved
        </span>
      </div>

      {versions && (
        <div>
          <span id="ksdm-dbs-version">
            <VersionItem title="Software version" value={versions.software} />
            {' | '}
            <VersionItem title="Master DB version" value={versions.master} />
            {' | '}
            <VersionItem title="CMS DB version" value={versions.cms} />
          </span>
        </div>
      )}
    </footer>
  );
};

export default memo(KaiSelectFooter);
